/* Cute Things: language renders on cards and product pages, and the offer price display.
   1) Bespoke starting zoom and shift per product (fallback).
   2) White background: each photo's background colour is measured and corrected to white (the reflection stays).
   3) Cards only: the nameplate is found in the photo that is showing and centred at one common size.
   4) Price, option D: serif offer price first, original price struck through and muted, no GBP, a gold "Save" ribbon on the top left of card photos
      and a "Free gift box" tag on the top right, and on product pages a gold "Save" line plus "Included: free gift box" under the price.
      The black Sale badge is removed. */
(function () {
  var fb = {
    'georgian-name-necklace': 'translate(2%,5%) scale(1)',
    'tamil-name-necklace': 'translate(0%,4%) scale(1)',
    'russian-name-necklace': 'translate(0%,-9%) scale(1)',
    'chinese-name-necklace': 'translate(0%,-7%) scale(1.19)',
    'korean-name-necklace': 'translate(-2.8%,2.8%) scale(1.38)'
  };
  var css = Object.keys(fb).map(function (h) {
    return '.card-wrapper:has(a[href$="/products/' + h + '"]) .card__media .media img{transform:' + fb[h] + ';transform-origin:50% 50%}';
  }).join('\n');
  css += '\n' + [
    '.price .price__badge-sale{display:none!important}',
    '.price--on-sale .price__regular{display:none!important}',
    '.price--on-sale .price__sale{display:flex!important;flex-direction:row-reverse;justify-content:flex-end;align-items:baseline;gap:.9rem}',
    '.price--on-sale .price__sale .price-item--regular{display:inline!important}',
    '.price-item--sale,.price:not(.price--on-sale) .price-item--regular{font-family:"Cormorant Garamond",Georgia,serif;font-weight:600;color:#111;letter-spacing:0}',
    '.price--on-sale .price-item--regular{font-family:"Cormorant Garamond",Georgia,serif;font-weight:500;color:#8B867D;text-decoration:line-through}',
    '.card-wrapper .price-item--sale,.card-wrapper .price:not(.price--on-sale) .price-item--regular{font-size:2rem}',
    '.card-wrapper .price--on-sale .price-item--regular{font-size:1.5rem}',
    'product-info .price-item--sale,product-info .price:not(.price--on-sale) .price-item--regular{font-size:3.2rem;line-height:1.1}',
    'product-info .price--on-sale .price-item--regular{font-size:2rem}',
    'product-info .price--on-sale .price__sale{gap:1.2rem}',
    '.ct-ribbon{position:absolute;left:0;top:0;z-index:2;background:#B08D57;color:#fff;font:500 1.1rem/1 Jost,system-ui,sans-serif;letter-spacing:.06em;padding:.55rem 1rem}',
    '.ct-gift{position:absolute;right:0;top:0;z-index:2;display:flex;align-items:center;gap:.5rem;background:rgba(255,255,255,.94);color:#96702F;border-left:1px solid #B08D57;border-bottom:1px solid #B08D57;font:500 1.05rem/1 Jost,system-ui,sans-serif;letter-spacing:.05em;padding:.55rem .9rem}',
    '.ct-gift svg{width:1.3rem;height:1.3rem;flex:none}',
    '@media (max-width:480px){.ct-ribbon{font-size:1rem;padding:.5rem .7rem}.ct-gift{font-size:.95rem;padding:.5rem .6rem}}',
    '.ct-save{display:block;margin:.8rem 0 0;font:500 1.4rem/1.3 Jost,system-ui,sans-serif;letter-spacing:.04em;color:#96702F}',
    '.ct-incl{display:block;margin:.3rem 0 0;font:400 1.3rem/1.3 Jost,system-ui,sans-serif;letter-spacing:.03em;color:#6B6762}'
  ].join('\n');
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);
})();

(function () {
  function num(t) { var m = String(t || '').replace(/[^0-9.]/g, ''); return parseFloat(m); }
  function tidy(el) {
    var tx = el.textContent, n = tx.replace(/\s*GBP/g, '').replace(/(\d)\.00\b/g, '$1');
    if (n !== tx) el.textContent = n;
  }
  function fmt(v) { return '£' + (Math.round(v * 100) % 100 === 0 ? Math.round(v) : v.toFixed(2)); }
  var NOINCL = /\/products\/(frosted-finish-upgrade|necklace-symbol-add-on)/;
  var GIFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4"/><path d="M12 8v13M5 12v9h14v-9M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>';
  function saveOf(p) {
    var reg = num((p.querySelector('.price-item--regular') || {}).textContent), sale = num((p.querySelector('.price-item--sale') || {}).textContent);
    return reg - sale;
  }
  function priceFix() {
    document.querySelectorAll('.price-item').forEach(tidy);
    document.querySelectorAll('.card-wrapper').forEach(function (card) {
      var inner = card.querySelector('.card__inner');
      if (!inner) return;
      var link = card.querySelector('a[href*="/products/"]');
      /* free gift box tag, top right of the photo */
      var gift = card.querySelector('.ct-gift');
      if (link && NOINCL.test(link.getAttribute('href') || '')) { if (gift) gift.remove(); }
      else if (!gift) { gift = document.createElement('span'); gift.className = 'ct-gift'; gift.innerHTML = GIFT + '<span>Free gift box</span>'; inner.appendChild(gift); }
      /* save ribbon, top left */
      var p = card.querySelector('.price--on-sale');
      var old = card.querySelector('.ct-ribbon');
      if (!p) { if (old) old.remove(); return; }
      var save = saveOf(p);
      if (!(save > 0)) { if (old) old.remove(); return; }
      var label = 'Save ' + fmt(save);
      if (old) { if (old.textContent !== label) old.textContent = label; }
      else { var r = document.createElement('span'); r.className = 'ct-ribbon'; r.textContent = label; inner.appendChild(r); }
      card.querySelectorAll('.card__badge .badge').forEach(function (b) { if (/^\s*sale\s*$/i.test(b.textContent)) b.style.display = 'none'; });
    });
    /* product page: gold Save line, then the gift box line, under the price */
    document.querySelectorAll('product-info .price').forEach(function (p) {
      var wrap = p.parentNode;
      if (!wrap || NOINCL.test(location.pathname)) return;
      var save = p.classList.contains('price--on-sale') ? saveOf(p) : 0;
      var sv = wrap.querySelector('.ct-save'), inc = wrap.querySelector('.ct-incl');
      if (save > 0) {
        var label = 'Save ' + fmt(save);
        if (sv) { if (sv.textContent !== label) sv.textContent = label; }
        else { sv = document.createElement('span'); sv.className = 'ct-save'; sv.textContent = label; p.insertAdjacentElement('afterend', sv); }
      } else if (sv) sv.remove();
      if (!inc) {
        inc = document.createElement('span'); inc.className = 'ct-incl'; inc.textContent = 'Included: free gift box';
        (sv || p).insertAdjacentElement('afterend', inc);
      } else if (sv && inc.previousElementSibling !== sv) sv.insertAdjacentElement('afterend', inc);
    });
  }
  var pt;
  function schedule() { clearTimeout(pt); pt = setTimeout(priceFix, 120); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
  window.addEventListener('load', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();

(function () {
  var LANG = /(korean|japanese|chinese|russian|greek|tamil|georgian|arabic|bengali|bangla|hindi|custom-language)/;
  var SKIP = /(bracelet|charms|arabic-name-necklace-1)/;
  var cache = {}, wbCache = {}, wbN = 0;

  function strip(u) { return String(u || '').split('?')[0]; }

  function measure(url) {
    if (cache[url]) return cache[url];
    cache[url] = new Promise(function (res) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var W = im.naturalWidth, H = im.naturalHeight;
          if (!W || !H) return res(null);
          var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
          var ctx = cv.getContext('2d', { willReadFrequently: true });
          ctx.drawImage(im, 0, 0);
          var d = ctx.getImageData(0, 0, W, H).data, x, y, i, b = 8, n = 0, r0 = 0, g0 = 0, b0 = 0;
          var spots = [[0, 0], [W - b, 0], [0, Math.floor(H / 2)], [W - b, Math.floor(H / 2)]];
          spots.forEach(function (c) {
            for (y = c[1]; y < c[1] + b; y++) for (x = c[0]; x < c[0] + b; x++) { i = (y * W + x) * 4; r0 += d[i]; g0 += d[i + 1]; b0 += d[i + 2]; n++; }
          });
          r0 /= n; g0 /= n; b0 /= n;
          if (0.3 * r0 + 0.59 * g0 + 0.11 * b0 < 150) return res(null);
          var gain = [Math.min(1.15, 255 / r0), Math.min(1.15, 255 / g0), Math.min(1.15, 255 / b0)];
          var out = { W: W, H: H, bg: 'rgb(' + Math.round(r0) + ',' + Math.round(g0) + ',' + Math.round(b0) + ')', gain: gain, plate: null };
          var rows = new Array(H).fill(0), mask = new Uint8Array(W * H), maxRow = 0;
          for (y = 0; y < H; y++) {
            for (x = 0; x < W; x++) {
              i = (y * W + x) * 4;
              if (Math.max(Math.abs(d[i] - r0), Math.abs(d[i + 1] - g0), Math.abs(d[i + 2] - b0)) > 55) { mask[y * W + x] = 1; rows[y]++; }
            }
            if (rows[y] > maxRow) maxRow = rows[y];
          }
          if (maxRow >= W * 0.06) {
            var y0 = -1, y1 = -1, thr = maxRow * 0.4;
            for (y = 0; y < H; y++) { if (rows[y] >= thr) { if (y0 < 0) y0 = y; y1 = y; } else if (y0 >= 0 && y - y1 > 3) break; }
            if (y0 >= 0) {
              var x0 = W, x1 = -1;
              for (x = 0; x < W; x++) {
                var cnt = 0;
                for (y = y0; y <= y1; y++) cnt += mask[y * W + x];
                if (cnt >= 2) { if (x < x0) x0 = x; if (x > x1) x1 = x; }
              }
              var pw = x1 - x0;
              if (x1 >= 0 && pw >= W * 0.12 && pw <= W * 0.95) out.plate = { cx: (x0 + x1) / 2, cy: (y0 + y1) / 2, pw: pw };
            }
          }
          res(out);
        } catch (e) { res(null); }
      };
      im.onerror = function () { res(null); };
      im.src = url;
    });
    return cache[url];
  }

  function wbFilter(g) {
    var k = g.map(function (v) { return v.toFixed(3); }).join(',');
    if (wbCache[k]) return wbCache[k];
    var id = 'ctwb' + (++wbN), ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('width', '0'); svg.setAttribute('height', '0'); svg.setAttribute('aria-hidden', 'true');
    svg.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden';
    svg.innerHTML = '<filter id="' + id + '" color-interpolation-filters="sRGB"><feColorMatrix type="matrix" values="' + g[0].toFixed(3) + ' 0 0 0 0  0 ' + g[1].toFixed(3) + ' 0 0 0  0 0 ' + g[2].toFixed(3) + ' 0 0  0 0 0 1 0"/></filter>';
    document.body.appendChild(svg);
    wbCache[k] = id;
    return id;
  }
  function whiten(img, m) {
    var g = m.gain;
    if (Math.max(g[0], g[1], g[2]) < 1.012) { img.style.filter = ''; return false; }
    img.style.filter = 'url(#' + wbFilter(g) + ')';
    return true;
  }

  function applyCard(img) {
    var card = img.closest('.card-wrapper');
    if (!card) return;
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (!LANG.test(href) || SKIP.test(href)) return;
    var src = img.currentSrc || img.src;
    if (!src) return;
    measure(strip(src) + '?width=240').then(function (m) {
      if (!m) return;
      var media = img.parentElement, white = whiten(img, m);
      media.style.background = white ? '#fff' : m.bg;
      if (!m.plate) return;
      var box = media.getBoundingClientRect(), cw = box.width, ch = box.height;
      if (!cw || !ch) return;
      var k = Math.max(cw / m.W, ch / m.H);
      var x = cw / 2 + (m.plate.cx - m.W / 2) * k, y = ch / 2 + (m.plate.cy - m.H / 2) * k;
      var s = Math.min(2.4, Math.max(0.85, (0.62 * cw) / (m.plate.pw * k)));
      var tx = cw * 0.5 - s * x, ty = ch * 0.5 - s * y;
      img.style.transformOrigin = '0 0';
      img.style.transform = 'translate(' + (tx / cw * 100).toFixed(2) + '%,' + (ty / ch * 100).toFixed(2) + '%) scale(' + s.toFixed(3) + ')';
    });
  }

  function applyGallery(img) {
    var src = img.currentSrc || img.src;
    if (!src) return;
    measure(strip(src) + '?width=240').then(function (m) { if (m) whiten(img, m); });
  }

  function hook(img, fn) {
    if (img.getAttribute('data-cfit')) return;
    img.setAttribute('data-cfit', '1');
    img.addEventListener('load', function () { fn(img); });
    if (img.complete && img.naturalWidth) fn(img);
  }

  function scan() {
    document.querySelectorAll('.card-wrapper .card__media img').forEach(function (img) { hook(img, applyCard); });
    if (window.CT_LANG_HANDLE && !SKIP.test(window.CT_LANG_HANDLE)) {
      document.querySelectorAll('media-gallery img').forEach(function (img) { hook(img, applyGallery); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  window.addEventListener('load', scan);
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 200); }).observe(document.documentElement, { childList: true, subtree: true });
})();